import { IShipmentGroup } from "@faire/web-api/faire/carts/IShipmentGroup";

import { ILeanCartItemV2 } from "@faire/retailer/stores/domain/CartStore/consts";

// Used as a placeholder for ship time when it is undefined
export const ASAP_SHIP_TIME = "ASAP";
// Used as a placeholder for ship time when it is a pending cart item
export const PENDING_SHIP_TIME = "PENDING";
// Use as a placeholder for ship time when it is blank;
export const EMPTY_SHIP_TIME = "";

// These functions are almost identical, someone smarter than me can probably consolidate them
export const generateShipMonthToBrandCartItemsMap = (
  shipmentGroups: IShipmentGroup[],
  cartProducts: ILeanCartItemV2[],
  useEmptyStringAsDefault?: boolean
): Map<string, ILeanCartItemV2[]> => {
  const brandCartProductMap = new Map<string, ILeanCartItemV2[]>();
  const defaultEmptyString = useEmptyStringAsDefault
    ? EMPTY_SHIP_TIME
    : ASAP_SHIP_TIME;

  // The Backend should've already sorted the shipment groups by date/title.
  shipmentGroups?.forEach((group) => {
    const products = cartProducts.filter((product) => {
      return product.token && group.cart_item_tokens.includes(product.token);
    });
    if (products.length) {
      const startDate =
        group.title && products[0]?.expected_ship_date
          ? group.title
          : defaultEmptyString;
      brandCartProductMap.set(startDate, products);
    }
  });
  return brandCartProductMap;
};
